import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Vitamin D",
      artist: "fantompower",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/3b73a510169f14c4af83ac4016e809917412702b-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#F7F6FA", "#755176"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=22790",
    },
    {
      name: "Odyssey",
      artist: "Smile High, Teddy Roxpin",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/08/af3ce13ad39d38057f00144f8a7c295877ccfec1-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#40858E", "[#A7DAD7"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=23337",
    },

    {
      name: "Where The Sun Goes",
      artist: "Delayde",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/09/6a9ef8ac00e168d3308fdf9e336874c03fab829d-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#F29EE9", "#95DD9B"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=23188",
    },

    {
      name: "Esfera",
      artist: "Juan Rios, Djemeia",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/4163ebb931e06d4ee8eb184295c0246d4a5055f7-1024x1024.jpg",
      id: uuidv4(),
      active: true,
      color: ["#FFA38F", "#826A76"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=21646",
    },
    {
      name: "Fallin",
      artist: "Ruck P, Jaz L",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/034f52eeaeceb144cca67b0930d705d32fc39e37-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#EC828A", "#655F7F"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=20561",
    },

    {
      name: "Move",
      artist: "fantompower",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/3b73a510169f14c4af83ac4016e809917412702b-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#F7F6FA", "#755176"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=22791",
    },
    {
      name: "Cabana",
      artist: "Juan Rios",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/4163ebb931e06d4ee8eb184295c0246d4a5055f7-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#FFA38F", "#826A76"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=21647",
    },

    {
      name: "As Long As I Got You",
      artist: "Ruck P , Djemeia",
      cover:
        "https://chillhop.com/wp-content/uploads/2018/07/Artwork-Ruck-P-Destination-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#A66E3F", "#3E1D0F"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=8157",
    },

    {
      name: "What if I told you",
      artist: "Juan Rios",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/4163ebb931e06d4ee8eb184295c0246d4a5055f7-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#FFA38F", "#826A76"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=21649",
    },
    {
      name: "Blue",
      artist: "Delayde",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/09/6a9ef8ac00e168d3308fdf9e336874c03fab829d-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#F29EE9", "#95DD9B"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=23195",
    },
    {
      name: "Places",
      artist: "Ruck P",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/07/034f52eeaeceb144cca67b0930d705d32fc39e37-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#EC828A", "#655F7F"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=20563",
    },
    {
      name: "Destination",
      artist: "Ruck P ",
      cover:
        "https://chillhop.com/wp-content/uploads/2018/07/Artwork-Ruck-P-Destination-1024x1024.jpg",
      id: uuidv4(),
      active: false,
      color: ["#A66E3F", "#3E1D0F"],
      audio: "https://mp3.chillhop.com/serve.php/?mp3=8160",
    },
  ];
}
export default chillHop;
